import React from "react";
import {
  ShoppingBag, Radio, Video, Boxes, PackageSearch, Gift, Sparkles, MapPin,
  GraduationCap, BookOpen, Award, Library, Store, LayoutDashboard, Palette,
  TrendingUp, Plug, Users, Activity, DollarSign, Image, FileText, FileCheck,
  Scale, HelpCircle, MessageSquare, LayoutGrid, CreditCard,
} from "lucide-react";

const MAP = {
  ShoppingBag, Radio, Video, Boxes, PackageSearch, Gift, Sparkles, MapPin,
  GraduationCap, BookOpen, Award, Library, Store, LayoutDashboard, Palette,
  TrendingUp, Plug, Users, Activity, DollarSign, Image, FileText, FileCheck,
  Scale, HelpCircle, MessageSquare, LayoutGrid, CreditCard,
};

export const ICON_NAMES = Object.keys(MAP);

export const HubIcon = ({ name, className }) => {
  const C = MAP[name] || LayoutGrid;
  return <C className={className} />;
};

export default HubIcon;
